"use client";

import React from "react";
import { Clock, Mail, MapPin, Navigation, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurStudioLocation() {
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="110845" id="our-london-office" className="relative w-full h-[600px] md:h-[700px] bg-background text-foreground overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/dark_mode_city_map_bg.png)] bg-cover bg-center opacity-40" />

      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_10%,rgba(10,15,30,0.85)_100%)] pointer-events-none" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center pointer-events-none">
        <div className="bg-primary text-primary-foreground p-3 rounded-full shadow-[0_0_40px_rgba(212,175,55,0.4)] animate-bounce">
          <MapPin className="size-8" />
        </div>
        <div className="w-6 h-1.5 bg-black/60 rounded-[100%] mt-2 blur-[3px]" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 h-full flex items-end md:items-center pb-8 md:pb-0">
        <div ref={cardRef} className={`w-full max-w-md transition-all duration-1000 ease-out ${isCardVisible ? "opacity-100 translate-y-0 md:translate-x-0" : "opacity-0 translate-y-12 md:translate-y-0 md:-translate-x-12"}`}>
          <Card className="bg-card/90 backdrop-blur-xl border-border/20 shadow-2xl rounded-xl">
            <CardHeader>
              <CardTitle className="text-3xl font-bold tracking-tight font-default text-foreground">
                Our London Office
              </CardTitle>
              <CardDescription className="text-base font-default text-muted-foreground">Visit our Holborn headquarters to discuss your social impact investment strategy.</CardDescription>
            </CardHeader>
            <CardContent className="space-y-5">
              <div className="flex items-start gap-3">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <MapPin className="size-5 text-primary" />
                </div>
                <div className="mt-1">
                  <p className="text-sm font-semibold font-default text-foreground">Address</p>
                  <p className="text-sm font-default text-muted-foreground mt-0.5">15-17 Jockey's Fields, London WC1R 4BW</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <Clock className="size-5 text-primary" />
                </div>
                <div className="mt-1">
                  <p className="text-sm font-semibold font-default text-foreground">
                    Investor Relations Hours
                  </p>
                  <p className="text-sm font-default text-muted-foreground mt-0.5">
                    Mon-Fri: 9:00am - 6:00pm
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <Phone className="size-5 text-primary" />
                </div>
                <div className="mt-1">
                  <p className="text-sm font-semibold font-default text-foreground">Phone</p>
                  <p className="text-sm font-default text-muted-foreground mt-0.5">+44 (0) 20 8142 6235</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <Mail className="size-5 text-primary" />
                </div>
                <div className="mt-1">
                  <p className="text-sm font-semibold font-default text-foreground">Email</p>
                  <p className="text-sm font-default text-muted-foreground mt-0.5">buy@10percent-yield.com</p>
                </div>
              </div>
            </CardContent>
            <CardFooter>
              <Button asChild size="lg" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl shadow-primary/20 font-default">
                <Link to="https://share.google/qlgp1wDo0HppvEYDr" newTab>
                  <Navigation className="size-4 mr-2" />
                  Get Directions
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}